import { type FC } from "react";

import ResetPasswordForm from "~/features/auth/login/components/ResetPasswordForm";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import { useResetPasswordLogic } from "~/features/auth/login/hooks/useResetPasswordLogic";
import { useTranslation } from "react-i18next";

const ResetPasswordPage: FC = () => {
  const { t } = useTranslation();
  const { onResetSuccess } = useResetPasswordLogic();

  return (
    <>
      <PageTitle className={"mt-gutter"} title={t("forgottenPwd.title")} />

      <div style={resetPwdBoxStyle}>
        <ResetPasswordForm onSuccess={onResetSuccess} />
      </div>
    </>
  );
};

const resetPwdBoxStyle = {
  maxWidth: "50%",
};

export function createResetPasswordPage() {
  return <ResetPasswordPage />;
}
